import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CardResolverComponent } from './card-resolver.component';
import { ReviewCardRendererResolverComponent } from './review-card-renderer-resolver.component';

const components = [CardResolverComponent, ReviewCardRendererResolverComponent];
@NgModule({
  declarations: [...components],
  exports: [...components],
  imports: [CommonModule]
})
export class CardResolverModule {}
